import {
  Box,
  Container,
  Stack,
  Typography,
  useMediaQuery
} from '@mui/material';
import Cielogo from '../../icons/Cielogo';
import { useTranslation } from 'react-i18next';
import { links } from '../../links';
import { Link } from 'react-router';
import { theme } from '@pagopa/mui-italia';

const Header = () => {
  const { t } = useTranslation();
  const smUp = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <>
      <Box component={'header'}>
        <Box bgcolor={'customBlue.main'} p={2}>
          <Container>
            <Stack direction={'row'} justifyContent={'space-between'}>
              <Typography
                to={links.header}
                target="_blank"
                rel="noopener noreferrer"
                component={Link}
                color={'primary.contrastText'}
                fontWeight={'600'}
                variant="body2"
                sx={{ textDecoration: 'none' }}
              >
                {t('commons.ministryOfInterior')}
              </Typography>
              {smUp && ( // show public area link only on large screens
                <Typography
                  to={links.public}
                  target="_blank"
                  rel="noopener noreferrer"
                  component={Link}
                  color={'primary.contrastText'}
                  fontWeight={'600'}
                  variant="body2"
                  sx={{ textDecoration: 'none' }}
                >
                  {t('header.publicArea')}
                </Typography>
              )}
            </Stack>
          </Container>
        </Box>
        <Box p={2} bgcolor={'primary.main'}>
          <Container>
            <Cielogo title={'Logo ' + t('commons.cieTitle')} />
          </Container>
        </Box>
      </Box>
    </>
  );
};

export default Header;
